export default "/images/vendor/flag-icon-css/flags/4x3/vu.svg?25acc79729c1d8a104b6a5d1afc4c9fa";